module.exports = __webpack_public_path__ + "static/media/quote2.18b45b98.png";